import Core from '_abstracts/core'

export default class ThirdStatistics {
    constructor () {
        Core.Status.update('statistics', 'status', 'finished')

        Core.Tasks.add(Core.Events.CHANGE_CONTENT, () => {
            this.sendVirtualPage()
        })
    }

    /**
     *  Envia a página virtual
     *
     */
    sendVirtualPage () {
        this.sendViewToAnalytics()

        this.sendViewToChartBeat()

        this.sendViewToCxense()
    }

    /**
     * Envia um evento de view para o CXense
     *
     */
    sendViewToCxense (referrer) {
        try {
            window.cX = window.cX || {}
            window.cX.callQueue = window.cX.callQueue || []
            window.cX.callQueue.push(['initializePage'])
            window.cX.callQueue.push(['setSiteId', '1141875083272162426'])
            window.cX.callQueue.push(['sendPageViewEvent',
                {
                    location: Core.Config.get('siteURL') + Core.Content.get('URL'),
                    referrer
                }
            ])

            console.log('Cxense Call Queue:', window.cX.callQueue)
        } catch (ex) {
            console.error(ex)
        }
    }

    /**
     * Envia um evento de view para o Analytics
     *
     */
    sendViewToAnalytics () {
        try {
            if (window.gtag) {
                window.gtag('config', 'UA-23088598-1', {
                    page_location: Core.Config.get('siteURL') + Core.Content.get('URL'),
                    page_path: this.model.get('url'),
                    page_title: this.model.get('title')
                })
                // gtag("event", "page_view", { send_to: "UA-23088598-1" });
            } else {
                console.info('gtag não encontrado')
            }
        } catch (ex) {
            console.error(ex)
        }
    }

    /**
     * Envia um evento de view para o Chartbeat
     *
     */
    sendViewToChartBeat () {
        try {
            window._sf_async_config.path = Core.Content.get('URL')
            window._sf_async_config.virtualReferrer = this.referrer
        } catch (ex) {
            console.info('chartbeat')
        }
    }
}
